/**
 * @generated SignedSource<<df6e16d6657757b1f15a4331f046b1df>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Root_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ExternalComplaint_query" | "Providers_query">;
  readonly " $fragmentType": "Root_query";
};
export type Root_query$key = {
  readonly " $data"?: Root_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"Root_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Root_query",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Providers_query"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ExternalComplaint_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "d1cc153c9a52a19964f969da9b5560f9";

export default node;
